// extracted by mini-css-extract-plugin
module.exports = {"root":"TipsBanner_root__vQK3w","text":"TipsBanner_text__SJgdc","title":"TipsBanner_title__TQi9o","link":"TipsBanner_link__1qkHA"};